import { consoleRoutes } from "@sagot/constants";
import { useWorkspaceContext } from "../../session/workspace-context";
import { useActiveAgent } from "../../shell/use-agents";

export interface GraphLinks {
  /** The Knowledge Base of the agent last opened (the agents list while there is none). */
  knowledge: string;
  /** That agent's Retrieval settings, where the knowledge graph is switched on. */
  agentRetrieval: string;
  billing: string;
  source: (sourceId: string) => string;
  /** The graph page, optionally with one item open, keeping the list's filters (`search` = `?q=...`). */
  graph: (entityId?: string, search?: string) => string;
}

export function useGraphLinks(): GraphLinks {
  const { summary } = useWorkspaceContext();
  const { active } = useActiveAgent(null);
  const slug = summary.slug;
  return {
    knowledge: active ? consoleRoutes.knowledge(slug, active.id) : consoleRoutes.agents(slug),
    agentRetrieval: active ? consoleRoutes.agentSettings(slug, active.id, "retrieval") : consoleRoutes.agents(slug),
    billing: consoleRoutes.billing(slug),
    source: (sourceId) => consoleRoutes.sourceDetail(slug, sourceId),
    graph: (entityId, search = "") => `${consoleRoutes.knowledgeGraph(slug, entityId)}${search}`,
  };
}
